import { render, staticRenderFns } from "./DefaultScoreModal.vue?vue&type=template&id=92da73e0&"
import script from "./DefaultScoreModal.vue?vue&type=script&lang=js&"
export * from "./DefaultScoreModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports